import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../models/restResponse.mode';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly baseUrl = `${environment.base_url}/products`;

  constructor(private http: HttpClient) {}

  getAll(
    searchTerm: string,
    active: boolean | null,
    minimumStock: boolean,
    negativeStock: boolean,
    page: number,
    includePromotionPricing = false,
    paginate = true
  ): Observable<RestResponse<Product[]>> {
    return this.http.get<RestResponse<Product[]>>(
      `${this.baseUrl}/list?search=${encodeURIComponent(searchTerm)}&active=${active}&minimumStock=${minimumStock}&negativeStock=${negativeStock}&page=${page}&includePromotionPricing=${includePromotionPricing}&paginate=${paginate}`
    );
  }

  getById(id: number): Observable<RestResponse<Product>> {
    return this.http.get<RestResponse<Product>>(`${this.baseUrl}/find/${id}`);
  }

  create(product: Partial<Product> | Record<string, unknown>): Observable<Product> {
    return this.http.post<Product>(`${this.baseUrl}/save`, product);
  }

  update(
    id: number,
    product: Partial<Product> | Record<string, unknown>,
    replicateToFamily = false
  ): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, {
      product,
      replicateToFamily
    });
  }

  search(searchTerm: string, includePromotionPricing = false, paginate = false): Observable<RestResponse<Product[]>> {
    const s = encodeURIComponent(searchTerm);
    return this.http.get<RestResponse<Product[]>>(
      `${this.baseUrl}/list?search=${s}&active=true&minimumStock=false&negativeStock=false&page=1&includePromotionPricing=${includePromotionPricing}&paginate=${paginate}`
    );
  }

  getByCodeOrBarCode(
    codeOrBarCode: string,
    includePromotionPricing = false
  ): Observable<RestResponse<Product>> {
    const c = encodeURIComponent(codeOrBarCode);
    return this.http.get<RestResponse<Product>>(
      `${this.baseUrl}/find-by-code-or-bar-code/${c}?includePromotionPricing=${includePromotionPricing}`
    );
  }

  export(searchTerm: string, active: boolean | null, minimumStock: boolean, negativeStock: boolean): Observable<Blob> {
    return this.http.get<Blob>(`${this.baseUrl}/export-list?search=${searchTerm}&active=${active}&minimumStock=${minimumStock}&negativeStock=${negativeStock}`, 
      {
        responseType: 'blob' as 'json'
      }
  );
  }
}
